import { createVNode as _createVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "toolbar" }
const _hoisted_2 = { class: "zoom" }
const _hoisted_3 = /*#__PURE__*/_createVNode("b", { class: "label" }, "ZOOM", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("option", { value: "0.5" }, "50%", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("option", { value: "1" }, "100%", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("option", { value: "2" }, "200%", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("option", { value: "4" }, "400%", -1)
const _hoisted_8 = { class: "historyControls row" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "undo", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "redo", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.settings.zoom = $event))
      }, [
        _createVNode("option", {
          value: _ctx.settings.zoom,
          style: {"display":"none"}
        }, _toDisplayString((_ctx.settings.zoom * 100).toFixed(0)) + "%", 9, ["value"]),
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ], 512), [
        [
          _vModelSelect,
          _ctx.settings.zoom,
          void 0,
          { number: true }
        ]
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", {
        class: ["btnHstr", 
          _ctx.history.stack.length <= _ctx.history.hisotryIndex + 1 ? 'inactive' : ''
        ],
        onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => (_ctx.undo(...args)), ["stop"]))
      }, [
        _hoisted_9
      ], 2),
      _createVNode("div", {
        class: ["btnHstr", _ctx.history.hisotryIndex != 0 ? '' : 'inactive'],
        onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.redo(...args)), ["stop"]))
      }, [
        _hoisted_10
      ], 2)
    ])
  ]))
}